import React, { useContext } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Routes, Route } from 'react-router-dom';
import Pesquisa from './pesquisa';
import Visualizacao from './visualizacao';
import Utils from '../../utils';
import {
    SttLoading,
    SttTranslateHook
} from '@stt-componentes/core';
import { signal } from '@preact/signals-react';
import { useSignals } from '@preact/signals-react/runtime';

const useStyles = makeStyles(theme => ({
    carregando: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%'
    },
}));

const gerandoPdf = signal(false);

const Aba = (props) => {
    const { strings } = useContext(SttTranslateHook.I18nContext);
    const { ...other } = props;
    const classes = useStyles();
    useSignals();

    const imprimir = (idExame) => {
        gerandoPdf.value = true
        Utils.imprimirFn({ id: idExame }, () =>  gerandoPdf.value = false);
    }

    const imprimirProtocolo = (exame) => {
        gerandoPdf.value = true;
        Utils.imprimirProtocoloFn(exame, () => gerandoPdf.value = false);
    }

    const imprimirTermo = (exame) => {
        gerandoPdf.value = true;
        Utils.imprimirTcleFn({ id: exame.id_paciente }, () => gerandoPdf.value = false);
    }

    return (
        <>
            <Routes>
                <Route path="/visualizar/:id" element={<Visualizacao imprimirFn={imprimir} imprimirProtocoloFn={imprimirProtocolo} imprimirTermoFn={imprimirTermo} />} />
                <Route path="/visualizar" element={<Visualizacao imprimirFn={imprimir} imprimirProtocoloFn={imprimirProtocolo} imprimirTermoFn={imprimirTermo} />} />
                <Route path="/" element={<Pesquisa {...other} imprimirFn={imprimir} imprimirProtocoloFn={imprimirProtocolo} imprimirTermoFn={imprimirTermo} />} />
            </Routes>
            <div className={classes.carregando}>
                <SttLoading
                    open={gerandoPdf.value}
                    text={strings.gerandoDocumento}
                />
            </div>
        </>
    );

}

export default Aba;